import * as React from 'react';
import { CardStyled } from './card.component.style';
export const Card = (props) => {
    return React.createElement(CardStyled, Object.assign({}, props));
};
